var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFulltilt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 77,
    height: 22,
    viewBox: "0 0 77 22"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M.365.118H6.99v8.753H.365z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M.365.118H6.99v8.753H.365z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M35.484 0h39.854v21.59H35.484z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h77v22H0z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#A92227",
    d: "M36.844 2.112h36.688L50.974 20.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M1.048 6.22L0 14.736h3.166l.403-3.27h4.3l.226-1.832h-4.3l.188-1.532h4.774L8.99 6.22zm9.339-.237h2.968l-.668 5.468c-.045.372-.078.756.25 1.054.23.235.61.322.988.322.507 0 .86-.16 1.066-.31.414-.31.476-.694.52-1.066l.669-5.468h2.981l-.57 4.662c-.121 1.004-.28 2.306-1.602 3.285-.813.596-1.777 1.042-3.355 1.042-1.508 0-2.481-.421-3.158-1.042-.913-.842-.808-1.821-.724-2.74l.635-5.207z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.634 5.983)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M1.393.118h3.1l-.768 6.55h3.264L6.73 8.87H.365z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.44 5.983)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M1.393.118h3.101l-.769 6.55H6.99L6.73 8.87H.365z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M55.08 5.667l.364-3.406-17.71 3.21-.36 3.336 7.74-1.354-.785 9.83 4.05-.75.957-9.842z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M51.676 8.248l-.833 7.862 3.272-.62.832-7.865zm5.518-6.31L55.9 15.187l3.483-.644 1.324-13.246zm7.767 11.54c-2.223.423-3.638-.22-3.483-2.34l.413-4.059-.569.105.266-2.816.606-.1.27-3.319L65.75.384 65.44 3.7l2.783-.558-.309 2.816-2.826.567-.28 2.863c-.057.792.462.825 1.078.707.175-.032.93-.222 1.02-.258l-.007 2.985c-.38.15-1.41.556-1.938.657"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2E2925",
    d: "M66.106 0l-.41.07-3.286.565-.243.042-.02.246-.046.564h-1.092l.016-.159.042-.42-.417.075-2.759.504H35.484l.394.513 2.348 3.058-.548.099-.234.043-.026.236-.36 3.337-.046.42.417-.072 3.453-.604 3.467 4.515-.338 4.225-.033.414.409-.075 3.035-.562 3.3 4.295.2.262.254-.21 7.826-6.444.439-.08.236-.044.023-.239.023-.23 1.78-1.466c.331.537.986 1.04 2.277 1.04.376 0 .793-.042 1.24-.127.544-.104 1.538-.494 1.963-.66l.032-.013.202-.08v-.216l.008-2.985.001-.47-.437.173c-.087.031-.794.21-.96.24a2.104 2.104 0 01-.39.046.537.537 0 01-.196-.027l9.409-7.747.686-.565h-9.371l.1-1.073.039-.414zm-.489 1.806h8.832l-9.62 7.922c.07.316.304.417.61.417.137 0 .289-.02.447-.051.176-.032.93-.222 1.02-.258l-.007 2.985c-.38.15-1.41.556-1.938.657-.425.08-.82.122-1.18.122-1.09 0-1.862-.382-2.167-1.226l-2.195 1.807-.036.362-.52.096-7.89 6.496-3.417-4.45-3.227.598.347-4.348-3.659-4.765-3.643.637.36-3.337 1.062-.192-2.666-3.472h21.79l2.788-.51-.05.51h1.737l.07-.857L65.75.384l-.133 1.422z"
  })))));
}
SvgFulltilt.displayName = 'Fulltilt';
export default SvgFulltilt;